import nanoid from 'nanoid'

export default () => {
  return 'local_' + nanoid(5)
}

export const isLocalId = (id) => {
  return id && id.toString().indexOf('local_') === 0
}

export const convertSnakeToCamel = (camelStr) => {
  let snakeStr = ''
  let camelLetters = camelStr.split('')
  for (let i = 0; i < camelLetters.length; i++) {
    if (camelLetters[i] === '_') {
      snakeStr += camelLetters[++i].toUpperCase()
    } else {
      snakeStr += camelLetters[i]
    }
  }
  return snakeStr
}

/**
 * Convert server api field name to client for correct nomalization\denormalization
 * You should use only real server fields ends with `_id` like `contact_id` in your code
 * @param item
 * @param serverIdfields - ids what will be converted, e.g. employee_post_bind_id (cenverted employeePostBind)
 * @returns item
 */
export const restoreIds = (item, serverIdfields = []) => {
  for (let field of serverIdfields) {
    let originField = field
    if (field.indexOf('_id') === field.length - 3) {
      field = field.slice(0, field.length - 3)
    }
    let camelField = convertSnakeToCamel(field)
    if (typeof item[originField] !== 'undefined' && typeof item[camelField] !== 'object' && item[originField] !== item[camelField]) {
      item[camelField] = item[originField]
    }
  }
  return item
}
